import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  // 🛑 Lógica para deshabilitar completamente la consola en producción
  if (window) {
    // Incluye todos los métodos que quieres silenciar, incluyendo 'error'
    const methods = ['log', 'debug', 'warn', 'info', 'table', 'clear', 'error'];
    
    methods.forEach(method => {
      // Reemplaza el método nativo de la consola con una función vacía
      (window.console as any)[method] = function() {};
    });
  }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  // Esta línea ahora será silenciosa en producción
  .catch(err => console.error(err));
